import axios from "axios";
import Vue from "vue";
import qs from "qs";
import { Message } from "element-ui";
import Cookies from "js-cookie";
import { getToken, getUserId, getMaterialToken } from "@/utils/auth";
// import { baseURL } from "@/config/config.js";
import { baseURL } from "../config/config.js";

// axios 配置
console.log(baseURL);
const service = axios.create({
  timeout: 0, // 请求的超时时间
  withCredentials: true, // 允许携带cookie
  baseURL: baseURL
});

service.defaults.headers.post["Content-Type"] =
  "application/x-www-form-urlencoded;charset=UTF-8";

// 请求拦截器
service.interceptors.request.use(
  config => {
    // 携带Token
    getToken() ? (config.headers.Authorization = "Bearer " + getToken()) : null;
    getUserId() ? (config.headers.UserId = getUserId()) : null;
    getMaterialToken()
      ? (config.headers.Token = "Bearer " + getMaterialToken())
      : null;
    // config.headers.Token = 'Bearer 6c545533ac178fef02a7f2a755919c32'

    return config;
  },
  error => {
    console.log("err" + error); // for debug
    Message({
      message: error.message,
      type: "error",
      duration: 5 * 1000
    });

    return Promise.reject(error);
  }
);
// 响应拦截器状态判断
service.interceptors.response.use(
  res => {
    return res;
  },
  error => {
    if (error.response) {
      switch (error.response.status) {
        case 504:
          Message({
            type: "error",
            message: "连接服务器失败，请稍后重试"
          });
          break;
        case 500:
          Message({
            type: "error",
            message: error.response.statusText
          });
          break;
      }
    }
    return Promise.reject(error);
  }
);

export default service;



// WEBPACK FOOTER //
// ./src/utils/service.js